import { render, staticRenderFns } from "./LoadRow.vue?vue&type=template&id=bbbc1c82&scoped=true"
import script from "./LoadRow.vue?vue&type=script&lang=js"
export * from "./LoadRow.vue?vue&type=script&lang=js"
import style0 from "./LoadRow.vue?vue&type=style&index=0&id=bbbc1c82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc1c82",
  null
  
)

export default component.exports